import { AlertTriangle } from "lucide-react";

const Lines = ({ data, team }) => {
  const byId = Object.fromEntries(data.players.map((p) => [p.id, p]));
  const rows = data.stats.filter((s) => s.team === team && byId[s.player_id]);
  const list = (key) => rows.filter((s) => s[key] > 0).sort((a, b) => b[key] - a[key]);
  const item = (s, key, testid) => (
    <li key={s.player_id} data-testid={`${testid}-${s.player_id}`} className="flex justify-between gap-1">
      <span className="truncate">{byId[s.player_id].short_name}</span><span className="num font-bold">×{s[key]}</span>
    </li>
  );
  const goals = list("goals");
  const assists = list("assists");
  return (
    <div className="flex-1 px-3 pb-3 text-xs space-y-2" data-testid={`score-details-${team}`}>
      <div>
        <p className="text-[9px] font-black tracking-widest opacity-60">BUTS</p>
        {goals.length ? <ul className="space-y-0.5 mt-0.5">{goals.map((s) => item(s, "goals", "scorer"))}</ul> : <p className="opacity-50">—</p>}
      </div>
      <div>
        <p className="text-[9px] font-black tracking-widest opacity-60">PASSES DÉCISIVES</p>
        {assists.length ? <ul className="space-y-0.5 mt-0.5">{assists.map((s) => item(s, "assists", "assister"))}</ul> : <p className="opacity-50">—</p>}
      </div>
    </div>
  );
};

export const ScoreBoard = ({ data }) => {
  const m = data.match;
  const sum = { white: 0, black: 0 };
  data.stats.forEach((s) => (sum[s.team] = (sum[s.team] || 0) + s.goals));
  const hasScore = m.white_score !== null && m.white_score !== undefined;
  const warnings = hasScore
    ? ["white", "black"].map((t) => ({ t, score: m[`${t}_score`], got: sum[t] })).filter((w) => w.score !== w.got)
    : [];
  return (
    <div data-testid="scoreboard">
      <div className="flex items-stretch rounded-3xl overflow-hidden border border-slate-200 shadow-sm">
        <div className="flex-1 bg-white text-zinc-950 py-3 text-center">
          <p className="text-[10px] font-black tracking-widest">BLANC</p>
          <p data-testid="score-white" className="num text-4xl font-black">{hasScore ? m.white_score : sum.white}</p>
        </div>
        <div className="flex-1 bg-zinc-950 text-white py-3 text-center">
          <p className="text-[10px] font-black tracking-widest">NOIR</p>
          <p data-testid="score-black" className="num text-4xl font-black">{hasScore ? m.black_score : sum.black}</p>
        </div>
      </div>
      <div className="flex items-stretch rounded-3xl overflow-hidden border border-slate-200 shadow-sm mt-2 pt-3">
        <div className="flex-1 flex bg-white text-zinc-950"><Lines data={data} team="white" /></div>
        <div className="flex-1 flex bg-zinc-950 text-white"><Lines data={data} team="black" /></div>
      </div>
      {warnings.map((w) => (
        <p key={w.t} data-testid={`score-warning-${w.t}`} className="mt-2 flex gap-2 items-start text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-xl px-3 py-2">
          <AlertTriangle className="w-4 h-4 shrink-0" />
          Attention : le score {w.t === "white" ? "Blanc" : "Noir"} indique {w.score} but{w.score > 1 ? "s" : ""} mais {w.got} but{w.got > 1 ? "s ont" : " a"} été attribué{w.got > 1 ? "s" : ""} aux joueurs.
        </p>
      ))}
    </div>
  );
};
